import clsx from 'clsx';
import React, { FC, useState, useEffect } from 'react';
import type { FeaturedProductsProps } from '../types';
import { ProductSection } from '../ProductSection';
import {
  handleFeaturedProductClick,
  handleFeaturedProductsAllClick,
  observerCallbackOnFeaturedProducts,
} from './FeaturedProducts.events';
import {
  getCookieConsentForRefresh,
  checkCookieBotReinitialized,
} from '../../../recommendations/recommendations-helper';
import { getConsentData } from '../../../../helpers/CookiebotHelper';
import type { ConsentData } from '../../../../helpers/CookiebotHelper';

export const FeaturedProducts: FC<FeaturedProductsProps> = ({
  featuredProducts,
  showLoginOrRecentOrders = false,
  audiencesDataFromSegment,
  audienceOverRideForPlayground,
}) => {
  // TODO(consent): use the `useConsent` hook instead of `getConsentData` and move it to the component
  // you're actually using it in instead of prop drilling
  const [consentData, setConsentData] = useState<ConsentData | undefined>(undefined);
  useEffect(() => {
    const isCookieBotInitComplete = checkCookieBotReinitialized();
    if (isCookieBotInitComplete) {
      /**
       * If CookieBot is set, set the consent data retrieved via getConsentData() method
       */
      setConsentData(getConsentData());
    } else {
      /**
       * If CookieBot is not set (Manually page refresh),
       * set the consent data retrieved via getCookieConsentForRefresh() method,
       * which gets cookie consent from the document cookies set by by cookieBot
       * Note: This is an edge case, but we need this for override playground
       * we are building for targeted audience types
       */
      setConsentData(getCookieConsentForRefresh('CookieConsent'));
    }
  }, []);

  // Feature Products Setup.
  if (!featuredProducts) return null;

  /**
  * if logged or has orders span to 2 cols if not 1 cols
  */
  const classNamesForFeaturedProductSection = clsx(
    {
      'lg:pd-col-span-1': showLoginOrRecentOrders,
      'lg:pd-col-span-2': !showLoginOrRecentOrders,
    },
  );
  return (
    <div className={classNamesForFeaturedProductSection}>
      <ProductSection
        {...featuredProducts}
        cardVariant="square"
        consent={consentData}
        isFeaturedProductsList
        showHeader
        twoColumnBreakpoint="max-md"
        onClick={handleFeaturedProductClick}
        onImpression={observerCallbackOnFeaturedProducts}
        showLoginOrRecentOrders={showLoginOrRecentOrders}
        onLandingPageClick={handleFeaturedProductsAllClick}
        audiencesDataFromSegment={audiencesDataFromSegment}
        audienceOverRideForPlayground={audienceOverRideForPlayground}
      />
    </div>
  );
};
